
<div *ngIf="!isMatrix">
  <div class="row p-2 my-2" style="display: flex;justify-content: space-between;">
    <div *ngIf="showName" class="col-md-7 mat-body-1 displayFlex">
      <span [innerHTML]="question.safeHtmlContent" class="inputLabel-p" style="text-align: justify;"></span>
      <span style="margin-left: 8px;" *ngIf="question.questionToolTip">
      <img class="dupIcon-padd iconzoom cursor"
           matTooltip="{{question.questionToolTip}}"
           src="/assets/icons/information_tooltip.svg"
           alt="info icon"
           matTooltipClass="my-custom-tooltip"
           matTooltipPosition="above"/>
      </span>
    </div>
    <div  [ngClass]="{'col-md-4': showName}">     
      <div *ngFor="let option of question.options;let k = index;">       
        <input type="text" value="{{option.value}}" readonly 
        [ngClass]="{'pt-none':IsReadOnly}" 
        [hidden]="option.isQuesOptionVisible==false"
        [style.background-color]="option.selected ? 'var(--main-color)' : ''"
        [style.color]="option.selected ? 'white': ''"   
        class="blue-border mat-body-1 p-1 my-1 cursor m-1 txt-style font12"    
        (click)="onMultiChoiceOptionClick($event, option.value, k)" [ariaLabel]="option.value">
      </div>     
    </div>   
  </div>
</div>
<div *ngIf="errormgvisible" class="dvError offset-8">
  <div class="errormsg mat-body-1" *ngFor="let error of validationerrormessage">{{error}}</div>
</div>


